<div class="popup-danger-container" *ngIf="show">
  <div class="body">
    <div class="content">
      <div class="icon">
        <div>
          <svg-icon [src]="svgUrl()"></svg-icon>
        </div>
      </div>
      <div class="info">
        <h2>{{ title() }}</h2>
        <h4>
            <ng-content></ng-content>
        </h4>
      </div>
    </div>
  </div>
</div>
